export default "__VITE_ASSET__C7s67ncp__"